export function EditorialMarquee({ items, lang }) {
  const trackItems = [...items, ...items];
  return (
    <div className="editorial-marquee" data-testid="editorial-marquee-ribbon" aria-label={lang === "en" ? "Martinez Landscaping services" : "Servicios de Martinez Landscaping"}>
      <div className="editorial-marquee-track">
        {trackItems.map((item, index) => (
          <span className="marquee-item" key={`${item}-${index}`}>
            <span className="marquee-dot" aria-hidden="true" />
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
